<div mat-dialog-title>
  <mode-dialog-header [hideClose]="hideClose">
    <h1 heading>Switch Workspace to...</h1>
  </mode-dialog-header>
</div>
<div mat-dialog-content>
  <mode-loader
    *ngIf="data.isUserOrgsLoading$ | async"
    class="context-dialog-loading"
  ></mode-loader>
  <ul class="context-dialog-list" *ngIf="data.isUserOrgsComplete$ | async">
    <!-- Community option when already in the community context should come first in the list -->
    <ng-container
      *ngIf="data.currentOrg?.token === data.currentUser?.token"
      [ngTemplateOutlet]="communityWorkspaceTemplate"
      [ngTemplateOutletContext]="{ isCurrent: true }"
    ></ng-container>
    <!-- List of user workspaces -->
    <li mode-context-dialog-workspace
      *ngFor="let org of (data.userOrgs$ | async)"
      [header]="org.displayName"
      [avatar]="org.avatar"
      [username]="org.username"
      [current]="data.currentOrg?.token === org.token"
      [connectDatabaseElementId]="data.connectDatabaseElementId"
    >
      Create and edit reports from the <strong>{{ org.displayName }}</strong> Workspace.
    </li>
    <!-- Community option when not in the community context should come last in the list -->
    <ng-container
      *ngIf="data.currentOrg?.token !== data.currentUser?.token"
      [ngTemplateOutlet]="communityWorkspaceTemplate"
      [ngTemplateOutletContext]="{ isCurrent: false }"
    ></ng-container>
  </ul>
</div>
<!-- Options to create a new workspace -->
<div mat-dialog-actions class="actions">
  <p *ngIf="data.hasMemberOrgs$ | async; else noMemberOrgs">
    Need another <a href="#" (click)="confirmNewWorkspace()">Workspace?</a>
  </p>
  <ng-template #noMemberOrgs>
    <p>
      Switch to <a href="#" (click)="confirmNewStudioWorkspace()">Mode Studio?</a>
    </p>
  </ng-template>
</div>

<ng-template #communityWorkspaceTemplate
  let-isCurrent="isCurrent"
>
  <li mode-context-dialog-workspace
    [header]="appName + ' Community'"
    [isCommunity]="true"
    [username]="data.currentUser?.username"
    [current]="isCurrent"
  >
    Create and explore reports or learn SQL or Python in {{ appName }}'s public analysis community.
  </li>
</ng-template>
